export default __webpack_public_path__ + "static/hedgehogBookCoverFront-3f38996ea92029faff11212778a3f18b.png";